"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _reactModal = _interopRequireDefault(require("react-modal"));

var _media = require("../../../themes/settings/media");

var _colors = _interopRequireDefault(require("../../../themes/settings/colors"));

var _zIndex = _interopRequireDefault(require("../../../themes/settings/z-index"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getBorderColor = function getBorderColor(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  if (variant === 'error') return theme.colors.system.error;
  if (variant === 'warning') return theme.colors.system.warning;
  if (variant === 'success') return theme.colors.system.success;
  return "transparent";
};

var ModalStyled = (0, _styledComponents.default)(_reactModal.default).withConfig({
  displayName: "ModalContainer__ModalStyled",
  componentId: "sc-1p5oxeq-0"
})(["backface-visibility:hidden;background-color:", ";border-top:solid 4px ", ";box-shadow:none;display:flex;flex-direction:column;position:relative;height:100%;width:100%;padding:0;z-index:", ";@media (min-width:", ") and (min-height:601px){border-radius:4px;box-shadow:", ";max-width:", ";height:auto;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.neutral.white;
}, getBorderColor, function (_ref3) {
  var theme = _ref3.theme;
  return theme.zIndex.modal;
}, _media.medium, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shadows.large;
}, function (_ref5) {
  var size = _ref5.size;
  return size === 'large' ? "".concat((0, _polished.rem)('750px')) : "".concat((0, _polished.rem)('600px'));
});

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) {
      continue;
    }

    if (!Object.prototype.hasOwnProperty.call(obj, i)) {
      continue;
    }

    target[i] = obj[i];
  }

  return target;
}

var ModalContainer = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ModalContainer, _PureComponent);

  var _super = _createSuper(ModalContainer);

  function ModalContainer() {
    (0, _classCallCheck2.default)(this, ModalContainer);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ModalContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.appElement) {
        ModalStyled.setAppElement(this.props.appElement);
      } else {
        ModalStyled.setAppElement(document.body);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          isOpen = _this$props.isOpen,
          name = _this$props.name,
          onClose = _this$props.onClose,
          size = _this$props.size,
          variant = _this$props.variant; // props to pass through to react-modal

      var modalProps = _objectWithoutProperties(this.props, ['appElement', 'cancelText', 'children', 'className', 'confirmText', 'description', 'isOpen', 'isWorking', 'name', 'onCancel', 'onClose', 'onConfirm', 'onRequestClose', 'overlayClassName', 'portalClassName', 'size', 'titleText', 'variant']); // https://github.com/reactjs/react-modal/blob/master/docs/README.md


      return /*#__PURE__*/_react.default.createElement(ModalStyled, (0, _extends2.default)({
        ariaHideApp: false,
        className: "ui-modal ".concat(className),
        isOpen: isOpen,
        name: name,
        onAfterOpen: this.onAfterOpen,
        onRequestClose: onClose,
        style: {
          overlay: {
            alignItems: 'center',
            backgroundColor: (0, _polished.rgba)(_colors.default.neutral.black, 0.5),
            bottom: 0,
            display: 'flex',
            justifyContent: 'center',
            left: 0,
            overflowY: 'hidden',
            position: 'fixed',
            padding: (0, _polished.rem)('15px'),
            right: 0,
            top: 0,
            zIndex: _zIndex.default.overlay
          }
        },
        bodyOpenClassName: "ui-modal-base--open",
        overlayClassName: "ui-modal-overlay",
        portalClassName: "ui-portal-modal ui-base",
        role: "dialog",
        size: size,
        variant: variant,
        shouldCloseOnEsc: true,
        aria: {
          modal: 'true'
        }
      }, modalProps), children);
    }
  }]);
  return ModalContainer;
}(_react.PureComponent);

ModalContainer.defaultProps = {
  variant: 'informational',
  size: 'medium'
};
ModalContainer.propTypes = {
  /** Optional: Query selector or DOM element identifying the root of your app */
  appElement: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),

  /** Child content rendered inside Modal. */
  children: _propTypes.default.node.isRequired,

  /** Optional: className to add to Modal */
  className: _propTypes.default.string,

  /** Displays Modal if `true`. */
  isOpen: _propTypes.default.bool,

  /** _Required_ Name used for uniquely-labelling inner components of modal */
  name: _propTypes.default.string.isRequired,

  /** _Required_ event handler called when the modal is closed via close "X" icon in upper right corner.  */
  onClose: _propTypes.default.func.isRequired,

  /** _Optional_ prop that sets the size of modal; supports `[medium|large]`; default is `medium`. `size` can be used in conjunction with any `variant`. */
  size: _propTypes.default.oneOf(['medium', 'large']),

  /** _Optional_ prop that sets variant style for error, success, and warning messages; supports `[informational(default)|error|success|warning]`. */
  variant: _propTypes.default.oneOf(['informational', 'error', 'success', 'warning'])
};
var _default = ModalContainer;
exports.default = _default;
//# sourceMappingURL=ModalContainer.js.map